export default "__VITE_ASSET__BdT69qEG__"